export default "__VITE_ASSET__CTfYayKq__"